<template>
      <fiche-header :ressource="ressource"
                    @back="back"
                    @openAll="openAll"
                    @closeAll="closeAll">
      </fiche-header>
  <div class="fiche">
    <!-- Liste des sections de la fiche -->
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('TRANSACTION_ETABLISSEMENT')">
        <slot name="section-transaction-etablissement">
          <section-transaction-etablissement ref="TRANSACTION_ETABLISSEMENT"
                                             id="TRANSACTION_ETABLISSEMENT"
                                             :extended="isExtended('TRANSACTION_ETABLISSEMENT')"
                                             :showButton="true"
                                             :autoSave="true"
                                             :readOnly="readOnly"
                                             :moduleId="moduleId"
                                             :searchText="searchText"
                                             :ressourceHeader="ressource"
                                             :fiche="fiche"
                                             :owner=owner
                                             :support=selectedSupport
                                             :route="route"
                                             :attribut="attribut"
                                             @extended="setExtended"
                                             @fullscreen="setFullscreen"
                                             @status="updateStatus"
                                             @toggleCardView="toggleCardView"
                                             @selectItem = "selectItem">
          </section-transaction-etablissement>
        </slot>
    </v-col>
  </div>
</template>
<script lang="ts">
import { defineComponent, type PropType } from "vue";
import FicheBase from '@/framework/base/components/FicheBase';
import Route from '@/extend/classes/Route';
import { CiRouter } from '@/framework/base/helpers/NavHelper'
import { Fiches } from '@/generated/classes/AppSchema';
import Support from '@/extend/classes/Support';
import Transaction from '@/extend/classes/Transaction';
import { ObjTypes } from '@/generated/classes/ObjTypes';
import Owner from '@/generated/classes/Owner';
import FicheHeader from '@/framework/base/components/FicheHeader.vue';
import { GenFiche, RessourceGenFiche } from '@/generated/ressources/generatedRessources';
import SectionTransactionEtablissement from '@/extend/sections/SectionTransactionEtablissementExtend.vue';

export default defineComponent({
  extends: FicheBase,
  components: {
    SectionTransactionEtablissement,
    FicheHeader,
  },

  props: {
    support: {
      type: Object as PropType<Support>,
    },
  },

  created (): void {
    this.addFiches(this.sections);
  },

  data() {
    return {
      moduleId: 0,
      fiche: Fiches.TRANSACTION_ETABLISSEMENT,
      sections: [
        'TRANSACTION_ETABLISSEMENT',
      ],

    }
  },

  computed: {
    ressource () {
      return RessourceGenFiche(GenFiche.FICHE_TRANSACTION_ETABLISSEMENT);
    },

    selectedSupport (): Support {
      return this.support
    },
    owner (): Owner {
      const owner = new Owner();
      owner.objType =  ObjTypes.SUPPORT;
      owner.objId = this.support.id;
      return owner;
    },
  },
  methods: {
    ficheMounted () {
      this.onShowSectionChanged();
      this.setFocus();
    },

    setFocus (): void {
      if (this.isMounted) {
        let res = false;
        let first = '';
        const route = CiRouter.getRoute();
        const notifSection = route ? route.section : '';
        this.sections.forEach(section => {
          // @ts-expect-error : generated method
          if (this.isDisplayed(section) && this.$refs[section] && this.$refs[section].allReadOnly && this.$refs[section].setFocus) {
            if (notifSection == section) {
              // @ts-expect-error : generated method
              this.$refs[section].setFocus(route);
              res = true;
            } else if (first == '') {
              first = section;
            }
          }
        })
        if (!res && first != '' && this.$refs[first]) {
          // @ts-expect-error : generated method
          this.$refs[first].setFocus(route);
        }
      }
    },

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isDisplayed (value: string): boolean {
      return true;
    }
  }
})
</script>
